import React from 'react';

export const DeliveryTruckSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M36 24V27C36 29.2 34.2 31 32 31H29C29 29.9 28.1 29 27 29C25.9 29 25 29.9 25 31H11C11 29.9 10.1 29 9 29C7.9 29 7 29.9 7 31H4C1.8 31 0 29.2 0 27V24C0 21.8 1.8 20 4 20H32C34.2 20 36 21.8 36 24Z" fill={color} />
          <path fill-rule="evenodd" clipRule="evenodd" d="M18 12H7.2C4 12 3 14 3 14L0 20V25H19V13L18 12ZM2 20L4 16C4 16 5 14 7 14H9V20H2Z" fill={color} />
          <path d="M9 27C6.8 27 5 28.8 5 31C5 33.2 6.8 35 9 35C11.2 35 13 33.2 13 31C13 28.8 11.2 27 9 27ZM9 33C7.9 33 7 32.1 7 31C7 29.9 7.9 29 9 29C10.1 29 11 29.9 11 31C11 32.1 10.1 33 9 33Z" fill={color} />
          <path d="M27 27C24.8 27 23 28.8 23 31C23 33.2 24.8 35 27 35C29.2 35 31 33.2 31 31C31 28.8 29.2 27 27 27ZM27 33C25.9 33 25 32.1 25 31C25 29.9 25.9 29 27 29C28.1 29 29 29.9 29 31C29 32.1 28.1 33 27 33Z" fill={color} />
          <path d="M32 8H17C14.8 8 13 9.8 13 12V25H36V12C36 9.8 34.2 8 32 8Z" fill={color} />
        </svg>
        )
  }

        return (
        <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M36 27C36 29.209 34.209 31 32 31H4C1.791 31 0 29.209 0 27V24C0 21.791 1.791 20 4 20H32C34.209 20 36 21.791 36 24V27Z" fill="#FD2020" />
          <path d="M19 13L18.021 12H7.146C4 12 3 14 3 14L0 19.959V25H19V13Z" fill="#FFC700" />
          <path d="M9 20H2L4 16C4 16 5 14 7 14H9V20Z" fill="#50A5E6" />
          <path d="M9 35C11.2091 35 13 33.2091 13 31C13 28.7909 11.2091 27 9 27C6.79086 27 5 28.7909 5 31C5 33.2091 6.79086 35 9 35Z" fill={window?.settings?.secondary_color ?? '#04333b'} />
          <path d="M9 33C10.1046 33 11 32.1046 11 31C11 29.8954 10.1046 29 9 29C7.89543 29 7 29.8954 7 31C7 32.1046 7.89543 33 9 33Z" fill="#E7EBEB" />
          <path d="M27 35C29.2091 35 31 33.2091 31 31C31 28.7909 29.2091 27 27 27C24.7909 27 23 28.7909 23 31C23 33.2091 24.7909 35 27 35Z" fill={window?.settings?.secondary_color ?? '#04333b'} />
          <path d="M27 33C28.1046 33 29 32.1046 29 31C29 29.8954 28.1046 29 27 29C25.8954 29 25 29.8954 25 31C25 32.1046 25.8954 33 27 33Z" fill="#E7EBEB" />
          <path d="M32 8H17C14.791 8 13 9.791 13 12V25H36V12C36 9.791 34.209 8 32 8Z" fill="#E7EBEB" />
        </svg>
        )
}